import banner from 'sbf-design-system-component/banners/banner';
import 'sbf-design-system-component/accordions/accordion';
import 'sbf-design-system-component/forms/base';
import 'sbf-design-system/js/lib/parsley';
import 'lib/country-state-updater';

// Accordions
const accordions = $('.accordion');

accordions.each(function (ii) {
  const accordion = $(this);
  accordion.find('h3').click(function () {
    accordions.stop(true, true).find('.panel').stop(true, true);

    const isMobile = $('#is-lt-medium').is(':visible');

    // find other accordions that are open
    const openAccordions = accordions.not(accordion).not('.closed').addClass('closed').find('.panel');

    const text = $(this).next('.panel');
    if (accordion.hasClass('closed')) {
      accordion.removeClass('closed');

      if (isMobile) {
        // start of first accordion
        let scrollTo = accordions.eq(0).offset().top;
        // add height of collapsed accordion (height of h2 + margin bottom of accordion) times number of accordions before
        scrollTo += (+accordions.eq(0).css('margin-bottom').replace('px', '') + $(this).outerHeight(true)) * ii;
        $('html, body').animate({ scrollTop: `${scrollTo}px` }, 'fast');

        // Close any open accordions.
        openAccordions.slideUp('fast');
        // Open clicked accordion.
        text.slideDown('fast');
      } else {
        // Close any open accordions.
        openAccordions.slideUp('fast');
        // Open clicked accordion.
        text.slideDown('fast');
      }
    } else {
      accordion.addClass('closed');
      openAccordions.slideUp('fast');
      text.slideUp('fast');
    }
  });
});

accordions.addClass('closed').find('.panel').slideUp(0);

// Form
const $form = $('#event-application-form');

/**
 * Form submit button click.
 *
 * @param    object    e     An event object.
 * @return   none
 */
$('#frontend-organize-an-event-submit .tk-button').click(function (e) {
  // If in page edit mode.
  if (window.sbf.ce && window.sbf.ce.init) {
    return;
  }
  // Form field validation check.
  if (!validateFields()) {
    $('.invalid:first input').focus();
    if (!window.navigator.userAgent.match(/iPad|iPhone/i)) {
      $('html, body').animate({ scrollTop: $('.invalid:first').offset().top - 150 }, 300, function () {});
    }
    return;
  }
  // If recaptcha is enabled.
  if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
    // This console message is intentional to allow devs to see if the invisible recaptcha is loaded.
    console.info('Recaptcha enabled');
    // Execute recaptcha check.
    window.grecaptcha.execute();
  } else {
    postEventApplication();
  }
});

/**
 * Form submission event.
 *
 * @param    object    e     An event object.
 * @return   none
 */
$form.on('submit', function (e) {
  // Custom handling used so never allow the default submit action.
  e.preventDefault();
});

/**
 * Validate form field values.
 *
 * @return   bool
 */
function validateFields () {
  let requiredsValid = true;

  $form.find('[required]:visible').each(function (_i, el) {
    if (!validateField(el)) {
      $(el).closest('.inline-input').addClass('invalid');

      $form.addClass('form__error');
      requiredsValid = false;
    }
  });

  if (!requiredsValid) {
    banner.showError('Please provide the required information.', false, 4000);
    if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
      window.grecaptcha.reset();
    }
    return false;
  }

  return true;
}

/**
 * Validate a single form field value.
 *
 * @param    object    el    An html element.
 * @return   bool
 */
function validateField (el) {
  let valid = true;

  // special field checks first
  if (el.name === 'phone') {
    if (!validatePhoneNumber(el.value)) {
      valid = false;
    }
  }

  if (!valid || !$(el).parsley().isValid(true)) {
    return false;
  }
  return true;
}

/**
 * Validate a phone number value.
 *
 * @param    string    might_be_a_phone_number    A phone number string.
 * @return   bool
 */
function validatePhoneNumber (mightBeAPhoneNumber) {
  // strip anything that's not a digit and make sure there are 10 or more of what's left
  const onlyNumbers = mightBeAPhoneNumber.replace(/[^0-9]/g, '');
  // not requiring area code currently
  return onlyNumbers.length >= 7;
}

/**
 * Send event application data to the server.
 *
 * @return   none
 */
function postEventApplication () {
  const data = $('#event-application-form').serialize();
  const $submitButton = $('#frontend-organize-an-event-submit .tk-button');

  let url = `https://${window.location.host}`;
  url += '/organize-an-event/event-application.json';

  $.ajax({
    type: 'post',
    dataType: 'json',
    data,
    url,
    beforeSend: function (xhr) {
      banner.showSaving('Processing your event application...', false, false);
      $submitButton.hide();
    },
    success: function () {
      const utmSourceParamValue = new URL(document.location).searchParams.get('utm_source')?.toLowerCase();
      // Facebook Pixel - Ad Tracking
      if (window.fbq && utmSourceParamValue === 'facebook') {
        try {
          window.fbq('trackCustom', 'Registration Event', {
            utm_source: utmSourceParamValue
          });
        } catch (err) {
          console.warn(err);
        }
      }

      const redirect = `https://${window.location.host}/organize-an-event/thank-you`;
      window.location.href = redirect;
    },
    error: function (xhr) {
      banner.showError('Unable to process this event application.', true);
      if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
        window.grecaptcha.reset();
      }
      $submitButton.show();
    },
    complete: function (xhr) {}
  });
}

/**
 * Handle recaptcha response.
 *
 * @return   none
 */
window.captchaCallback = function (token) {
  // If recaptcha token is valid.
  if (token.length !== 0) {
    postEventApplication();
  } else if (window.grecaptcha) {
    banner.showError('An recaptcha error has occurred.', true);
    window.grecaptcha.reset();
  }
};
